module.exports = __webpack_public_path__ + "img/zsMapbg1.8f57b93a.png";